import { Box, Heading, Link } from '@chakra-ui/react';

interface Props {
  block: {
    type: number;
    label: string;
  };
  content: any;
  hideLabel?: boolean;
}

// Bare hostnames (no scheme) become relative URLs in <a href>, so the SPA catches
// the click instead of navigating away. Prepend https:// for anything that isn't
// already an absolute URL or a known non-http scheme.
function toAbsoluteHref(url: string): string {
  const trimmed = url.trim();
  if (!trimmed) return '';
  if (/^(https?:|mailto:|tel:|ftp:|sms:)/i.test(trimmed)) return trimmed;
  if (trimmed.startsWith('//')) return `https:${trimmed}`;
  return `https://${trimmed}`;
}

export default function LinkBlock({ block, content, hideLabel = false }: Props) {
  const rawUrl = typeof content === 'string' ? content : content?.value || '';
  const url = toAbsoluteHref(rawUrl);
  const label =
    (content && typeof content === 'object' && typeof content.text === 'string' && content.text) ||
    rawUrl;

  return (
    <Box>
      {!hideLabel && (
        <Heading as={'h3'} fontSize={'xl'} mb={2}>
          {block.label}
        </Heading>
      )}
      <Box pl={hideLabel ? 0 : 2}>
        <Link
          href={url}
          target='_blank'
          rel='noopener noreferrer'
          color='blue.fg'
          textStyle='sm'
          mr={2}
        >
          {label}
        </Link>
      </Box>
    </Box>
  );
}
